import React, { useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../../env";
import {
  validateText,
  sanitizeString,
} from "../../../../../../utils/inputValidator";

const AddFacility = () => {
  const [facility, setFacility] = useState({ title: "", description: "" });
  const [fieldErrors, setFieldErrors] = useState({});
  const [generalError, setGeneralError] = useState(null);
  const handleChange = (e) => {
    setFacility({ ...facility, [e.target.name]: e.target.value });
  };
  const validateForm = () => {
    const errors = {};

    // Validate Title
    if (!facility.title) {
      errors.title = "Facility title is required";
    } else {
      const titleValidation = validateText(facility.title, {
        minLength: 3,
        maxLength: 100,
        rejectHTML: true,
      });
      if (!titleValidation.isValid) errors.title = titleValidation.error;
    }

    // Validate Description
    if (!facility.description) {
      errors.description = "Facility description is required";
    } else {
      const descValidation = validateText(facility.description, {
        minLength: 3,
        maxLength: 500,
        rejectHTML: true,
      });
      if (!descValidation.isValid) errors.description = descValidation.error;
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setGeneralError(null);

    if (!validateForm()) {
      setGeneralError("Please fix the errors below");
      return;
    }
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/facilities/room-facilities`,
        {
          facilityID: facility.facilityID,
          facilityTitle: sanitizeString(facility.title),
          facilityDescription: sanitizeString(facility.description),
        },
      );

      alert("Facility added successfully!");
      setFacility({ title: "", description: "" });
      setFieldErrors({});
      setGeneralError(null);
    } catch (error) {
      alert("Error adding facility");
      console.error(error);
    }
  };

  return (
    <div
      className="modal fade"
      id="add-facilites"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Add Room Facility</h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {generalError && (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {generalError}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label text-muted">Facility Title</label>
                <input
                  type="text"
                  className={`form-control ${fieldErrors.title ? "is-invalid" : ""}`}
                  placeholder="Add Facility Title"
                  name="title"
                  value={facility.title}
                  onChange={handleChange}
                  required
                />
                {fieldErrors.title && (
                  <small className="text-danger">{fieldErrors.title}</small>
                )}
              </div>
              <div className="form-group mt-3">
                <label className="form-label text-muted">
                  Facility Description
                </label>
                <input
                  type="text"
                  className={`form-control ${fieldErrors.description ? "is-invalid" : ""}`}
                  placeholder="Add Facility Description"
                  name="description"
                  value={facility.description}
                  onChange={handleChange}
                  required
                />
                {fieldErrors.description && (
                  <small className="text-danger">
                    {fieldErrors.description}
                  </small>
                )}
              </div>
              <div className="modal-footer mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-secondary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFacility;
